import {ALL_OA} from './structures'
import {
  get,
  getWithExpansion,
  toArray,
  toArrayWithExpansion,
  getPhotoFromURL,
  getBy,
  uploadPhoto
} from './utils'
let openAsset = {}

ALL_OA.forEach((item, i) => {
  openAsset[item] = {}
});



for (let type in openAsset){
  openAsset[type].toArray = (limit, addquery)=>(toArray(type, limit, addquery))
  openAsset[type].toArrayWithExpansion = (limit, ...expansions )=>(toArrayWithExpansion(type, limit, ...expansions))
  openAsset[type].get = (id)=>(get(type, id))
  openAsset[type].getBy = (id, prop, ...expansions)=>(getBy(type, id, prop, ...expansions))
  openAsset[type].getWithExpansion = (id, ...expansions)=>(getWithExpansion(type, id, ...expansions))
  
}

openAsset.getPhotoFromURL = getPhotoFromURL
openAsset.uploadPhoto = uploadPhoto
export {openAsset}
